/**
 * 流媒体通用处理封装，兼容处理，方便调用
 */
import store from '@/store/index'
import { CHAT } from '@/common/websocket/index'
import { loginClose } from '@/common/rtc/mediasoup/mediasoup-util'
import { loginOutCloseSig } from '@/common/rtc/srs/video-platform'
import {
  closeResetMeet as TRTCCloseResetMeet,
  exitRemoteRoom,
  helmetJoinWaike,
  joinRoomTrtc,
} from '@/common/websocket/trtc-walkie'
import {
  closeResetMeet as closeResetMeetMediasoup,
  exitRemoteRoom as exitRemoteRoomMediasoup,
  outClose,
  helmetJoinSoup,
  joinRoomSoup,
} from '@/common/rtc/mediasoup/mediasoup-walkie'
import {
  closeResetMeetSRS,
  exitRemoteRoomSRS,
  helmetJoinMeetSRS,
  closeVideoWalkie,
} from '@/common/rtc/srs/video-walkie'

// 实时音视频服务类型
// 可选值：mediasoup srs=srs内部定制版 trtc=腾讯云实时音视频
// 备选值：cloudroom=云屋（目前暂未做适配工作，需要适配后才能使用）
let rtcType = store.getters.rtcType

/**
 * 实时音视频相关资源退出和销毁
 */
export function closeRTC() {
  rtcType = store.getters.rtcType
  // 彻底关闭ws连接
  CHAT.socket.send([{}])
  // 流媒体退出资源销毁
  switch (rtcType) {
    case 'trtc':
      // trtc不需要处理，将ws关闭即可
      break
    case 'srs':
      loginOutCloseSig()
      closeVideoWalkie()
      break
    case 'mediasoup':
      loginClose()
      outClose()
      break
    case 'cloudroom':
      // closeResetMeet()
      break
    default:
      console.error('not support rtctype', rtcType)
      break
  }
  // websocket退出
  if (window.CHAT.socket) {
    window.CHAT.socket.close()
  }
  CHAT.wsclose()
}

/**
 * 语音通话相关资源退出和销毁
 * type是否进入房间的退出: true 退出全部房间,false: 全部呼叫无人接听时 全部退出房间
 * allOne: all 全部退出，one：平台退出
 */
export function closeVoiceCall(waikIngInfo, type, allOne) {
  rtcType = store.getters.rtcType
  let userData = []
  for (let item of waikIngInfo.userList) {
    if (item.acceptCall === '1') {
      userData.push(item)
    }
  }
  if (waikIngInfo && waikIngInfo.userList && waikIngInfo.userList.length > 0) {
    store.commit('openWaike', false)
    // 流媒体退出资源销毁
    switch (rtcType) {
      case 'trtc':
        if (allOne !== 'one') {
          // 退出全部房间用户通话
          exitRemoteRoom(waikIngInfo, type)
        }
        // 退出当前用户通话
        TRTCCloseResetMeet()
        break
      case 'srs':
        if (userData.length === 1) {
          allOne = 'all'
        }
        if (allOne === 'all') {
          // 退出全部房间用户通话
          exitRemoteRoomSRS(waikIngInfo, type)
        }
        // 退出当前用户通话
        closeResetMeetSRS()
        break
      case 'mediasoup':
        if (allOne === 'all') {
          // / 退出全部房间用户通话
          exitRemoteRoomMediasoup(waikIngInfo, type)
        }
        // 退出当前用户通话
        closeResetMeetMediasoup()
        break
      case 'cloudroom':
        // 暂未处理
        break
      default:
        console.error('closeVoiceCall not support rtctype', rtcType)
        break
    }
  }
}
/**
 * 语音通话相关资源发送加入房间指令
 */
export function joinMeetWaike(helmetList, id) {
  rtcType = store.getters.rtcType
  if (helmetList && id) {
    store.commit('setVoiceCallCurrent', id)
    // 流媒体退出资源销毁
    switch (rtcType) {
      case 'trtc':
        // 发送加入房间指令
        helmetJoinWaike(helmetList, id)
        break
      case 'srs':
        // 发送加入房间指令
        helmetJoinMeetSRS(helmetList, id)
        break
      case 'mediasoup':
        // 发送加入房间指令
        helmetJoinSoup(helmetList, id)
        break
      case 'cloudroom':
        // 暂未处理
        break
      default:
        console.error('closeVoiceCall not support rtctype', rtcType)
        break
    }
  }
}
/**
 * 语音通话自己加入房间
 */
export function joinRoomWaike(roomId) {
  rtcType = store.getters.rtcType
  if (roomId) {
    // 流媒体退出资源销毁
    switch (rtcType) {
      case 'trtc':
        // 已加入房间，去创建流
        joinRoomTrtc(roomId)
        break
      case 'srs':
        // 不处理
        break
      case 'mediasoup':
        // 请求加入mediasoup房间，创建流
        joinRoomSoup(roomId)
        break
      case 'cloudroom':
        // 暂未处理
        break
      default:
        console.error('closeVoiceCall not support rtctype', rtcType)
        break
    }
  }
}
